// NodeTrash.js

export const NodeVisibility = {
	ACTIVE: 'active',
	ALL: 'all',
	TRASHED: 'trashed',
};

export const isNodeTrashed = (node) => {
	if (!node || typeof node !== 'object') return false;
	if (node.isTrashed === true) return true;
	return node.trashedAt != null;
};

export const filterNodesByVisibility = (rows = [], visibility = NodeVisibility.ACTIVE) => {
	const resolvedRows = Array.isArray(rows) ? rows : [];
	const resolvedVisibility = String(visibility || NodeVisibility.ACTIVE).trim().toLowerCase();

	if (resolvedVisibility === NodeVisibility.ALL) return resolvedRows;
	if (resolvedVisibility === NodeVisibility.TRASHED) {
		return resolvedRows.filter((row) => isNodeTrashed(row));
	}

	return resolvedRows.filter((row) => !isNodeTrashed(row));
};